import cn from 'classnames'
import React from 'react'

import styles from './MenuLayoutHeader.module.scss'

import { useMenuContext } from '~lib/ui-kit/MenuLayout/utils'

function MenuLayoutHeader({ className, children, ...elemProps }: React.HTMLAttributes<HTMLDivElement>) {
  const { variant: menuVariant } = useMenuContext()
  return (
    <div className={cn(styles.root, className, styles[menuVariant])} {...elemProps}>
      {children}
    </div>
  )
}

export default MenuLayoutHeader
